import { DotCMSGraphQLParams } from '@dotcms/types';

export const blogQuery = `
    search(query: "+contenttype:Blog +live:true", limit: 3) {
        title
        identifier
        ... on Blog {
            inode
            image {
                fileName
                fileAsset {
                    versionPath
                }
            }
            urlMap
            modDate
            urlTitle
            teaser
            author {
                firstName
                lastName
                inode
            }
        }
    }
`;

const page = `
urlContentMap{
              ... on Blog {
            inode
            imageBlog:image {
              path
              idPath
            }
            urlMap
            modDate
            urlTitle
            teaser
             author {
                firstName
                lastName
                inode
                profilePhoto{title path idPath}
            }
              blogComment{
              body
              postDate
              emailResponse
              contentType
              creationDate
              reply{
              postDate
              body
                 commentAuthor{
                firstName
                lastName
                inode
                profilePhoto{title path idPath}
              }
              }
              commentAuthor{
                firstName
                lastName
                inode
                profilePhoto{title path idPath}
              }

              }
        }
}
containers {
  containerContentlets {
    contentlets {
            ... on Blog {
            inode
            imageBlog:image {
              path
              idPath
            }
            urlMap
            modDate
            urlTitle
            teaser
             author {
                firstName
                lastName
                inode
                profilePhoto{title path idPath}
            }
            postingDate
        }
      ... on FaqWidget {
          faq {
            contentType
            question
            answer
          }
        }
        ... on Banner {
        title
        bannerTitle
        animations
        caption
        link
        buttonText
        layout
        backgroundColor
        imagelg { title path idPath}
        imagemd { title path idPath}
        imagesm { title path idPath}
        maxWidth
        textColor
        buttonColor
        expire
        publish
      }
        ... on BannerVideo {
        title
        caption
        bannerVideoTitle :bannerTitle
        link
        animations
        buttonText
        fileAsset { title path idPath}
        disableAutoplay
        buttonColor
        textColor
        cssClass
        }
        ... on Image {
        title
        animations
        fileAsset { title path idPath}
        description
        publishDate
        expireDate

        }
        ... on DefaultVideo{
        fileAsset { title path idPath}
        autoPlayVideo : autoPlay
        mute
        heightlg
        heightmd
        heightsm
        cssClass

        }
              ... on webPageContent {
        identifier
        title
        body
        modDate
        inode
        working
        live
        contentType
        creationDate
        baseType
        archived
      }
      ... on ProductCarousel {
        title
        productCarouselTitle
        noOfItems
        productSkus
        cssClass
        show
        slideItems
        showIndicator
        loop
        speed
        autoPlay
        layout
        publish
        expire
        }
              ... on Category {
        title
        categoryTitle
        allCategories
        cssClass
        listItemCssClass
        slideItems
        showIndicator
        loop
        speed
        autoPlay
        layout
        publish
        expire
        }
                      ... on CategoryCard {
        allCategories
        publish
        expire
        }
                ... on VideoVimeo{
        autoPlayVideo: autoPlay
        url
        mute
        heightlg
        heightmd
        heightsm
        cssClass

        }
                        ... on Video{
        title
        autoPlayVideo: autoPlay
        url
        mute
        heightlg
        heightmd
        heightsm
        cssClass
        publish
        expire
        carouselsortorder
        maxWidth
        }
              ... on ProductsTooltip {
        search
        tooltipDetails
        maxWidth
        image { title path idPath}
        imagemd { title path idPath}
        imagesm { title path idPath}
        }
        ... on GlobalCarousel{
          showIndicator
          loop
          maxWidth
          verticalCenter
          enableSpace
          animatePagination
          animateNavigation
          carouselSpeed:speed
          autoPlay
          navLayout
          noOfItems
          slideItems
              productsTooltip{
                contentType
                search
                tooltipDetails
                maxWidth
                image { title path idPath}
                imagemd { title path idPath}
                imagesm { title path idPath}
              }
              images{
                contentType
                animations
                title
                fileAsset { title path idPath}
                description
                publishDate
                expireDate
              }
              banners{
                contentType
                title
                caption
                animations
                link
                buttonText
                layout
                backgroundColor
                imagelg { title path idPath}
                imagemd { title path idPath}
                imagesm { title path idPath}
                maxWidth
                textColor
                buttonColor
                expire
                publish
             }
              videos{
                contentType
                title
                autoPlayVideo: autoPlay
                url
                mute
                heightlg
                heightmd
                heightsm
                cssClass
                publish
                expire
                carouselsortorder
                maxWidth
              }
              categoryCard{
                  contentType
                  allCategories
                  publish
                  expire
              }

        }
        ... on Carousel {
        startCycling
        slideItems
        maxWidth
        showIndicator
        slideInterval
        banners{
        contentType
        bannerTitle
        title
        caption
        link
        buttonText
        layout
        animations
        backgroundColor
        imagelg { title path idPath}
        imagemd { title path idPath}
        imagesm { title path idPath}
        maxWidth
        textColor
        buttonColor
        expire
        publish
        }
        videos{
        contentType
        title
        autoPlay
        url
        mute
        heightlg
        heightmd
        heightsm
        cssClass
        publish
        expire
        carouselsortorder
        maxWidth
        }
        productsTooltip{
        contentType
        search
        tooltipDetails
        maxWidth
        image { title path idPath}
        imagemd { title path idPath}
        imagesm { title path idPath}
        }
     }
    }
  }
}
`;

// const page = `
// fragment ClientPage on DotContentlet {
//   publishDate
//   inode
//   identifier
//   archived
//   urlMap
//   locked
//   contentType
//   creationDate
//   modDate
//   title
//   baseType
//   working
//   live
//   publishUser {
//     firstName
//     lastName
//   }
//   owner {
//     lastName
//   }
//   conLanguage {
//     language
//     languageCode
//   }
//   modUser {
//     firstName
//     lastName
//   }
//   faq {
//     question
//     answer
//   }
// }
// `;

// const pageFragment = `
// fragment ClientPage on DotPage {
//   publishDate
//   inode
//   identifier
//   archived
//   urlMap
//   locked
//   contentType
//   creationDate
//   modDate
//   title
//   baseType
//   working
//   live
//   publishUser {
//     firstName
//     lastName
//   }
//   owner {
//     lastName
//   }
//   conLanguage {
//     language
//     languageCode
//   }
//   modUser {
//     firstName
//     lastName
//   }
//   faq {
//     question
//     answer
//   }
// }
// `;

export const footerQuery = (identifier: string) => `
    search(
      query: "+contentType:webPageContent +identifier:${identifier} +live:true",
      limit: 1
    ) {
      ... on webPageContent {
        identifier
        title
        body
        modDate
        inode
        working
        live
        contentType
        creationDate
        baseType
        archived
      }
    }
`;
export const destinationQuery = `
    search(query: "+contenttype:Destination +live:true", limit: 3) {
        title
        identifier
        ... on Destination {
                inode
                image {
                fileName
                fileAsset {
                    versionPath
                }
                }
                urlMap
                modDate
                url
        }
    }
`;

/**
 * Generate nested children structure for GraphQL query
 */
function buildChildren(depth: number): string {
  if (depth <= 0) {
    return '';
  }
  return `
    children {
      ...NavProps
      ${buildChildren(depth - 1)}
    }
  `;
}

/**
 * Generate the full navigation query (without fragment definition)
 * because fragments are injected separately via BASE_EXTRA_QUERIES.fragments
 */
export function createNavigationQuery(depth: number): string {
  return `
    DotNavigation(uri: "/", depth: ${depth}) {
      ...NavProps
      ${buildChildren(depth)}
    }
  `;
}

export const navigationQuery = `
DotNavigation(uri: "/", depth: 5) {
  ...NavProps
  children {
    ...NavProps
  }
}
`;

export const fragmentNav = `
fragment NavProps on DotNavigation {
    code
    folder
    hash
    host
    href
    languageId
    order
    target
    title
    type
}
`;

export const BASE_EXTRA_QUERIES: DotCMSGraphQLParams = {
  page,
  content: {
    //     logoImage: `FileAssetCollection(query: "+title:logo.png") {
    //   fileAsset {
    //     versionPath
    //   }
    // }`,
    //     blogs: blogQuery,
    //     destinations: destinationQuery,
    // navigation: createNavigationQuery(5),
  },
  fragments: [],
};
